import React from 'react';
import { useLocation } from 'react-router-dom';

export const useSnackbar = (props = {}) => {
  const { shouldCloseWhenNavigated = true } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  const [message, setMessage] = React.useState();
  const [color, setColor] = React.useState('success');
  const [title, setTitle] = React.useState(null);
  const [autoClose, setAutoClose] = React.useState(true);
  const [currentPageUrl, setCurrentPageUrl] = React.useState('');
  const location = useLocation();

  React.useEffect(() => {
    let timer;
    if (isOpen && autoClose) {
      timer = setTimeout(() => {
        setIsOpen(false);
        setMessage('');
      }, 6500);
    }

    return () => clearTimeout(timer);
  }, [isOpen, autoClose]);

  React.useEffect(() => {
    if (
      currentPageUrl !== location.pathname &&
      isOpen &&
      shouldCloseWhenNavigated
    )
      setIsOpen(false);
  }, [location.pathname, isOpen, currentPageUrl, shouldCloseWhenNavigated]);

  const showSnackbar = ({
    message,
    color = 'success',
    title = null,
    autoClose = true,
  }) => {
    setCurrentPageUrl(location.pathname);
    setAutoClose(autoClose);
    setMessage(message);
    setTitle(title);
    setColor(color);
    setIsOpen(true);
  };

  const closeSnackbar = () => {
    setIsOpen(false);
    setMessage('');
    setCurrentPageUrl('');
  };

  return {
    isOpen,
    message,
    color,
    title,
    autoClose,
    showSnackbar,
    closeSnackbar,
    errortext: color === 'danger' && message,
    successtext: color === 'success' && message,
  };
};
